import React from "react";

const ReportHeader = ({ type, title, dateRange, setDateRange, onGenerate }) => {
  const showDateRange = () => {
    if (type === "close") return false;
    return true;
  };
  return (
    <div className="report-header">
      <h2>{title}</h2>
      {showDateRange() && (
        <div className="date-picker">
          <label>From:</label>
          <input
            type="date"
            value={dateRange.start}
            onChange={(e) =>
              setDateRange({ ...dateRange, start: e.target.value })
            }
          />
          <label>To:</label>
          <input
            type="date"
            value={dateRange.end}
            onChange={(e) =>
              setDateRange({ ...dateRange, end: e.target.value })
            }
          />
          <button onClick={onGenerate} className="btn btn-primary">
            Generate Report
          </button>
        </div>
      )}
    </div>
  );
};

export default ReportHeader;
